module.exports = __webpack_public_path__ + "static/media/snicker-ad.6f042bb3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/snicker-ad.gif
// module id = 346
// module chunks = 0